// extracted by mini-css-extract-plugin
export default {"container":"yL-z","timeTop":"zL-z","timeCountdown":"AL-z","cta":"BL-z","disabled":"CL-z","product":"DL-z"};